import React from "react";
import { Button } from "@design-system/Button/Button";
import { LeftArrowIcon, RightArrowIcon } from "@icons";
import styles from "./InvoicePreviewPager.module.scss";

interface Props {
    pageCount: number;
    pageIndex: number;
    onPageChange: (pageIndex: number) => void;
}

// Footer strip attached to the bottom of the invoice paper, mirroring the
// preview mode strip on top: it steps through the pages of a document too
// long for one page, so the preview never needs a scroll of its own.
export const InvoicePreviewPager: React.FC<Props> = ({
    pageCount,
    pageIndex,
    onPageChange,
}) => (
    <div className={styles.bar}>
        <Button
            type="button"
            variant="primary"
            size="md"
            iconOnly
            aria-label="Previous page"
            disabled={pageIndex === 0}
            onClick={() => onPageChange(pageIndex - 1)}
        >
            <LeftArrowIcon />
        </Button>
        <Button
            type="button"
            variant="primary"
            size="md"
            iconOnly
            aria-label="Next page"
            disabled={pageIndex === pageCount - 1}
            onClick={() => onPageChange(pageIndex + 1)}
        >
            <RightArrowIcon />
        </Button>
        {/* The visible count moved into the paper's footer (and hides with
            the Pagination toggle), so screen readers keep their own always-on
            announcement of the current page. */}
        <span className={styles.srOnlyCount} aria-live="polite">
            Page {pageIndex + 1} of {pageCount}
        </span>
    </div>
);
